import React from 'react';
import styled from 'styled-components';
import {FlexColumn} from '../../StyledUtils';

export const SlideContainer = styled.div` 
  display: flex;
  justify-content: center;
`;
